import { useEffect } from "react";
import { Nav, Footer } from "../components/Nav";
import poster from "../images/ACMW/ACM-W Poster.png";
import cover from "../images/ACMW/ACM-W Cover.png";

import {
  ProjectInfo,
  TextSection,
  MoreSection,
} from "../components/ProjectDetails";

export default function WebCrack() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <>
      <header id="project-cover">
        <Nav color="white" />

        <h1>ACM-W Flyers</h1>
        <p>
          A collection of social media flyers I created as the Director of Media
          for ACM-W, a women in Computer Science club.
        </p>
        <img src={cover} alt="ACM-W Flyer Cover" id="cover" />
      </header>

      <main id="project-detail-main">
        <ProjectInfo
          role={["Graphic Designer"]}
          team={["Solo Project"]}
          toolkit={["Figma"]}
          duration="1 Year (2023-2024)"
        />

        <TextSection
          type="callout"
          header="Final Designs"
          title="Original Flyer Design"
        >
          <img src={poster} alt="ACM-W Social Media Flyers" />
        </TextSection>
      </main>
      <MoreSection exclude={["acmw"]} />
      <Footer />
    </>
  );
}
